import { ItemSort, type Item } from '@/shared/graphql/router/graphql'
import { useExplorerStore } from '@/features/explorer/store'
import { isFile, isFolder } from './itemGuards'

const getItemTimestamp = (item: Item): number => {
  if (isFile(item)) {
    return item.copyright.registrations[0]?.timestamp ?? 0
  }
  return item.createdAt ?? 0
}

export const sortExplorerItems = (items: Item[]): Item[] => {
  const currentFolderStore = useExplorerStore()

  let folders = items.slice().filter(isFolder)
  let files = items.slice().filter(isFile)

  if (currentFolderStore.sortBy === ItemSort.NameAsc) {
    folders = folders.sort((a, b) => a.name.localeCompare(b.name))
    files = files.sort((a, b) => a.name.localeCompare(b.name))

    return [...folders, ...files]
  }

  if (currentFolderStore.sortBy === ItemSort.NameDesc) {
    folders = folders.sort((a, b) => a.name.localeCompare(b.name)).reverse()
    files = files.sort((a, b) => a.name.localeCompare(b.name)).reverse()

    return [...files, ...folders]
  }

  if (currentFolderStore.sortBy === ItemSort.TimestampAsc) {
    folders = folders.sort((a, b) => (a.createdAt ?? 0) - (b.createdAt ?? 0))
    files = files.sort((a, b) => getItemTimestamp(a) - getItemTimestamp(b))

    return [...files, ...folders]
  }

  if (currentFolderStore.sortBy === ItemSort.TimestampDesc) {
    folders = folders
      .sort((a, b) => (a.createdAt ?? 0) - (b.createdAt ?? 0))
      .reverse()
    files = files
      .sort((a, b) => getItemTimestamp(a) - getItemTimestamp(b))
      .reverse()

    return [...files, ...folders]
  }

  return []
}
